module.exports = __webpack_public_path__ + "static/media/main.a98605b4.png";